/**
 * A GTM helper to return the page section based on the current route.
 *
 * @returns The page section.
 *
 * @example
 * ```ts
 * const pageSection = usePageSection()
 * console.log(pageSection) // 'search_results'
 * ```
 */

const PAGE_SECTION_MAP: Record<string, string> = {
  // Core shop
  '': 'home',
  'welcome': 'welcome',
  'search': 'search_results',
  'c': 'category_products',
  'supplier': 'supplier_products',
  'suppliers': 'suppliers',
  'clinic-chain': 'clinic_chain_products',
  'product': 'product_detail',
  'barcode': 'barcode_scanner',
  // Cart & checkout
  'cart': 'cart',
  'checkout': 'checkout',
  'order-confirm': 'order_confirmation',
  'order-history': 'orders',
  // Shopping lists / favorites
  'shopping-lists': 'shopping_lists',
  'product-favorites': 'shopping_lists',
  // Campaigns
  'campaign': 'campaign',
  'campaigns': 'campaigns',
  // Auth
  'login': 'login',
  'register': 'registration',
  'forgot-password': 'forgot_password',
  'reset-password': 'reset_password',
  // Account
  'account': 'account',
  // Legal / static
  'agb': 'terms',
  'datasecurity': 'data_privacy',
  'imprint': 'imprint',
  'gutscheine': 'vouchers',
  // Supplier-facing public pages (e.g. /s/orders/[id])
  's': 'supplier_order_update',
}

/**
 * Resolve a GTM page section from a raw route path (locale prefix aware).
 */
export function resolvePageSection(path: string): string {
  const segment = path.replace(/^\/[a-z]{2}\//, '/').split('/')[1] ?? ''
  return PAGE_SECTION_MAP[segment] ?? segment
}

export function usePageSection(): string {
  const route = useRoute()
  return resolvePageSection(route.path)
}
